import * as React from "react";

function Preview() {
  return (
    <svg
      width="160"
      height="50"
      viewBox="0 0 160 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_805_2796)">
        <path
          d="M39.4222 31.5501V18.7422H46.8222V20.8246H41.8445V23.825H46.1778L45.7556 25.9298H41.8445V29.4677H46.8222V31.5501H39.4222Z"
          fill="#0074BD"
        />
        <path
          d="M60.1556 31.5501L54.1778 22.7279V31.5501H51.9111V18.7422H54.2222L59.9111 27.1166V18.7422H62.1778V31.5501H60.1556Z"
          fill="#0074BD"
        />
        <path
          d="M73.5556 31.5935H71.1556L66.3556 18.6289H69.0667L72.4445 28.4139L75.7778 18.7409H78.3334L73.5556 31.5935Z"
          fill="#0074BD"
        />
        <path
          d="M99.6888 31.6823C98.3111 31.7047 96.9333 31.3912 95.6888 30.809L96.0666 28.5699C97.1333 29.1968 98.4666 29.6895 99.7333 29.6895C100.867 29.6895 101.622 29.1521 101.622 28.1221C101.622 27.1816 101.178 26.7786 99.3333 25.9949C96.8666 24.9649 95.8666 24.1588 95.8666 22.1659C95.8666 19.9044 97.6 18.5833 99.9777 18.5833C101.133 18.5609 102.289 18.8296 103.333 19.367L102.978 21.5838C102.089 20.9792 101.044 20.6209 99.9777 20.5762C98.7555 20.5762 98.2222 21.1807 98.2222 21.942C98.2222 22.7481 98.6222 23.1512 100.4 23.8901C103.022 24.9649 103.978 25.8829 103.978 27.8534C103.956 30.3836 102.133 31.6823 99.6888 31.6823Z"
          fill="#0074BD"
        />
        <path
          d="M114.156 20.8694V31.5501H111.689V20.8694H107.933V18.7422H118.022L117.556 20.8694H114.156Z"
          fill="#0074BD"
        />
        <path
          d="M130.689 31.5501L124.711 22.7279V31.5501H122.444V18.7422H124.756L130.444 27.1166V18.7422H132.711V31.5501H130.689Z"
          fill="#0074BD"
        />
        <path
          d="M156.244 20.8694V31.5501H153.8V20.8694H150.022V18.7422H160L159.533 20.8694H156.244Z"
          fill="#0074BD"
        />
        <path
          d="M83 31.5042V18.7188H90.3778V20.8012H85.4222V23.8016H89.7556L89.3333 25.9064H85.4222V29.4442H90.4V31.5042H83Z"
          fill="#0074BD"
        />
        <path
          d="M138.378 31.5501V18.7422H145.756V20.8246H140.778V23.825H145.111L144.689 25.9522H140.778V29.4677H145.778V31.5501H138.378Z"
          fill="#0074BD"
        />
        <path
          d="M0 50.0019V41.4707L29.7778 31.7305V40.2392L0 50.0019Z"
          fill="#0074BD"
        />
        <path
          d="M0 39.0058V30.497L29.7778 20.7344V29.2431V29.2655L26.0222 30.497L0 39.0058Z"
          fill="#0074BD"
        />
        <path
          d="M0 8.50873V0L26.0222 8.50873L13.0222 12.7855L0 8.50873Z"
          fill="#0074BD"
        />
        <path
          d="M0 17.0418V10.9961L9.24444 14.0189L0 17.0418Z"
          fill="#0074BD"
        />
        <path
          d="M0 19.502L29.7778 9.76172V18.2705L0 28.0331V19.502Z"
          fill="#0074BD"
        />
      </g>
      <defs>
        <clipPath id="clip0_805_2796">
          <rect width="160" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Preview;
